export default {
	ADD_PRODUCT: 'ADD_PRODUCT',
	UPDATE_PRODUCT: 'UPDATE_PRODUCT',
	REMOVE_PRODUCT: 'REMOVE_PRODUCT',

	ADD_DOCUMENT: 'ADD_DOCUMENT',
	UPDATE_DOCUMENT: 'UPDATE_DOCUMENT',
	REMOVE_DOCUMENT: 'REMOVE_DOCUMENT',

	ADD_PROJECT: 'ADD_PROJECT',
	UPDATE_PROJECT: 'UPDATE_PROJECT',
	REMOVE_PROJECT: 'REMOVE_PROJECT',

	ADD_REFERENCE: 'ADD_REFERENCE',
	UPDATE_REFERENCE: 'UPDATE_REFERENCE',
	REMOVE_REFERENCE: 'REMOVE_REFERENCE',

	ADD_USER: 'ADD_USER',
	UPDATE_USER: 'UPDATE_USER',
	REMOVE_USER: 'REMOVE_USER',

	UPLOAD_PO_FILE: 'UPLOAD_PO_FILE',
	DOWNLOAD_PO_FILE: 'DOWNLOAD_PO_FILE',

	UPLOADING_FAILED: 'UPLOADING_FAILED',
	UPLOADING_SUCCEEDED: 'UPLOADING_SUCCEEDED',
	UPLOADING_IN_PROGRESS: 'UPLOADING_IN_PROGRESS',

	VALIDATE_FORM: 'VALIDATE_FORM',
	UPDATE_FORM: 'UPDATE_FORM',
	INIT_FORM: 'INIT_FORM',

	LOG_IN: 'LOG_IN',
	CHECK_CMS_ACCESS: 'CHECK_CMS_ACCESS',
	LOG_OUT: 'LOG_OUT',
	SET_TOKEN: 'SET_TOKEN',
	LOG_IN_FAILED: 'LOG_IN_FAILED',

	REMOVE_FAQ: 'REMOVE_FAQ',
	ADD_FAQ: 'ADD_FAQ',
	UPDATE_FAQ: 'UPDATE_FAQ',

	REMOVE_FAQ_ITEM: 'REMOVE_FAQ_ITEM',
};



// WEBPACK FOOTER //
// ./src/redux/cms/actionTypes.js